import Vue from 'vue'
import Router from 'vue-router'
import routes from './routes'
import registerBeforeHooks from './before'
import vbclass from 'vue-body-class'

Vue.use(Router)

const router = new Router({
  routes,
  mode: 'history',
  linkActiveClass: 'active'
})

Vue.use( vbclass, router )
registerBeforeHooks(router)

export default router
